<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Products (Store ID: {{id}})</h4>
            </div>

            <data-tables-server
              class="table-shopping"
              style="width: 100%"
              :data="products"
              :tool-bar="false"
              :total="total"
              :page-size="10"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
            >
              <el-table-column min-width="30" label="ID" prop="id">
                <template slot-scope="props">
                  <span>{{props.row.id}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="Title" prop="title">
                <template slot-scope="props">
                  <span>{{props.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Type" prop="type">
                <template slot-scope="props">
                  <span>{{props.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Currency" prop="currency_code">
                <template slot-scope="props">
                  <span>{{props.row.currency_code}}</span>
                </template>
              </el-table-column>
                <el-table-column min-width="50" label="View" prop="brochure">
                <template slot-scope="props">
                  <router-link :to="'/product/edit/'+props.row.id">Edit</router-link>
                </template>
              </el-table-column>
            </data-tables-server>

          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
export default {
  data() {
    return {
      storeId: 1,
      products: [],
      total: 0
    };
  },
  methods: {
    getProducts(id) {
      api
        .getProducts(id)
        .then(response => {
          console.log(response);
          this.products = response.data.products; 
          this.total = response.data.products.length;
          console.log(this.products.products);
        });
    }
  },

  async mounted() {
    this.id = this.$route.params.id;
    this.getProducts(this.$route.params.id);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Mailchimp/Products.vue